class SegmentedSelect {
    constructor(select, options) {
        this.options = $.extend({}, options);

        this.select = $(select);
        this.container = $('<div class="segmented-select"/>');
        if (this.options.class) this.container.addClass(this.options.class);
        if (this.options.vertical) this.container.addClass('vertical');
        this.select.wrap(this.container);
        this.segmentsContainer = $('<div class="segments" role="radiogroup"/>').appendTo(this.container);
        this.segments = [];

        var value = this.select.val();
        this.select.find('option').each($.proxy(function(index, option) {
            var segmentValue = $(option).attr('value');
            var segmentText = $(option).text();
            var selected = (value == segmentValue);
            this.segments.push(new SegmentedSelectSegment(this, segmentText, segmentValue, selected));
        }, this));
        this.setValue(value, true);

        // Copy data attributes to container
        for (var i = 0; i < this.select[0].attributes.length; i++) {
            var attr = this.select[0].attributes[i];
            if (/^data-/.test(attr.name)) {
                this.container.attr(attr.name, attr.value);
            }
        }

        // Copy name to container
        this.container.attr('data-name', this.select.attr('name'));
    }

    onFocus() { this.container.addClass('focus'); }
    onBlur() { this.container.removeClass('focus'); }

    setValue(value, initial) {
        for (var i = 0; i < this.segments.length; i++) {
            var segment = this.segments[i];
            if (segment.value == value) {
                this.selectedSegment = segment;
                segment.setSelected(true);
            } else if (segment.isSelected) {
                segment.setSelected(false);
            }
        }
        this.container.attr('value', value);
        this.select.val(value);
        if (!initial) this.select.trigger('change');
    }

    selectNext() {
        if (this.selectedSegment) {
            var index = this.segments.indexOf(this.selectedSegment) + 1;
            var segment = this.segments[index < this.segments.length ? index : 0];
            this.setValue(segment.value);
            segment.focus();
        }
    }

    selectPrev() {
        if (this.selectedSegment) {
            var index = this.segments.indexOf(this.selectedSegment) - 1;
            var segment = this.segments[index < 0 ? this.segments.length - 1 : index];
            this.setValue(segment.value);
            segment.focus();
        }
    }
}

class SegmentedSelectSegment {
    constructor(select, text, value, selected) {
        this.select = select;
        this.value = value;
        this.div = $('<div class="segment" role="radio"/>').appendTo(select.segmentsContainer);
        this.div.text(text);
        this.div.on('click', $.proxy(this.onClick, this));
        this.div.on('keydown', $.proxy(this.onKeyDown, this));
        this.div.on('focus', $.proxy(select.onFocus, select));
        this.div.on('blur', $.proxy(select.onBlur, select));
        this.setSelected(selected);
    }

    onClick() { if (!this.isSelected()) this.select.setValue(this.value); }

    onKeyDown(event) {
        switch (event.key) {
            case $.key.space:
            case $.key.return:
                break;

            case $.key.up:
            case $.key.left:
                this.select.selectPrev();
                break;

            case $.key.down:
            case $.key.right:
                this.select.selectNext();
                break;

            default:
                return;
        }
        event.preventDefault();
        event.stopPropagation();
    }

    focus() { this.div.focus(); }

    isSelected() { return this.div.hasClass('selected'); }

    setSelected(selected) {
        this.div.toggleClass('selected', selected)
                .attr('tabindex', selected ? '0' : '-1')
                .attr('aria-checked', selected ? 'true' : 'false');
    }
}

$.fn.segmentedSelect = function(options) {
    this.each(function(){
        new SegmentedSelect(this, options);
    });
    return this;
}
